import { render, staticRenderFns } from "./overlay_image_copy.vue?vue&type=template&id=33e902b1&scoped=true&lang=pug&"
import script from "./overlay_image_copy.vue?vue&type=script&lang=js&"
export * from "./overlay_image_copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e902b1",
  null
  
)

export default component.exports